// Page scroll lock shared by bottom drawers and search pickers: stacked and
// nested dialogs lock once and unlock when the last one closes. The scrollbar's
// width is replaced with body padding and a placeholder so the page does not
// shift sideways when the scrollbar disappears.

const SCROLLBAR_PLACEHOLDER_ID = "drawer-scrollbar-placeholder"
const OPEN_BODY_CLASS = "bottom-drawer-open"
const SCROLL_LOCKING_DIALOGS = "dialog.bottom-drawer[open], dialog.search-picker-dialog[open]"

let scrollLockState = null

function openDialogCount() {
  return document.querySelectorAll(SCROLL_LOCKING_DIALOGS).length
}

function scrollbarPlaceholderColorScheme() {
  const colorScheme = [
    window.getComputedStyle(document.body).colorScheme,
    window.getComputedStyle(document.documentElement).colorScheme
  ].find(scheme => scheme && scheme !== "normal")

  if (colorScheme) return colorScheme

  return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light"
}

function ensureScrollbarPlaceholder(scrollbarWidth) {
  let placeholder = document.getElementById(SCROLLBAR_PLACEHOLDER_ID)

  if (!placeholder) {
    placeholder = document.createElement("div")
    placeholder.id = SCROLLBAR_PLACEHOLDER_ID
    placeholder.className = "drawer-scrollbar-placeholder"
    placeholder.setAttribute("aria-hidden", "true")
    document.body.appendChild(placeholder)
  }

  placeholder.style.width = `${scrollbarWidth}px`
  placeholder.style.colorScheme = scrollbarPlaceholderColorScheme()
}

function lockPageScroll() {
  if (scrollLockState) {
    document.body.style.overflow = "hidden"
    return
  }

  // A restored Turbo snapshot can bring back a <body> that was locked when it
  // was cached. Those styles are artifacts, not the values to restore to, so
  // strip them before measuring.
  if (document.body.classList.contains(OPEN_BODY_CLASS)) unlockPageScroll()

  document.body.classList.add(OPEN_BODY_CLASS)

  const scrollbarWidth = Math.max(0, window.innerWidth - document.documentElement.clientWidth)
  const bodyPaddingRight = Number.parseFloat(window.getComputedStyle(document.body).paddingRight) || 0

  scrollLockState = {
    overflow: document.body.style.overflow,
    paddingRight: document.body.style.paddingRight
  }

  document.documentElement.style.setProperty("--drawer-scrollbar-width", `${scrollbarWidth}px`)

  if (scrollbarWidth > 0) {
    document.body.style.paddingRight = `${bodyPaddingRight + scrollbarWidth}px`
    ensureScrollbarPlaceholder(scrollbarWidth)
  }

  document.body.style.overflow = "hidden"
}

// Restores the saved body styles when this page locked the scroll, and clears
// them outright when there is nothing tracked to restore from.
function unlockPageScroll() {
  document.body.classList.remove(OPEN_BODY_CLASS)
  document.body.style.overflow = scrollLockState ? scrollLockState.overflow : ""
  document.body.style.paddingRight = scrollLockState ? scrollLockState.paddingRight : ""
  document.documentElement.style.removeProperty("--drawer-scrollbar-width")
  document.getElementById(SCROLLBAR_PLACEHOLDER_ID)?.remove()
  scrollLockState = null
}

export function syncPageScrollLock() {
  if (openDialogCount() > 0) {
    lockPageScroll()
  } else {
    unlockPageScroll()
  }
}
